// extracted by mini-css-extract-plugin
export default {"root":"IconQuestion_root__801Ct"};